export const config = {
    name: 'industryList',
    searchFields: [
        {
            name: '项目编码',
            value: 'projectCode',
            type: 'input',
            isFixed: true,
            span: 3
        },
        {
            name: '商机编码',
            value: 'opportunityCode',
            type: 'input',
            isFixed: true,
            span: 3
        },
        {
            name: '商机名称',
            value: 'opportunityName',
            type: 'input',
            isFixed: true,
            span: 3
        },
        {
            name: '客户',
            value: 'opportunityCustomerNames',
            type: 'advanceMulti',
            advanceConfig: [
                { prop: 'customerName', value: '客户名称' },
                { prop: 'customerCode', value: '客户编码' },
                { prop: 'customerGroupName', value: '客户系' }
            ],
            tableConfig: [
                { prop: 'customerName', value: '客户名称', 'displayName': 'customerName' },
                { prop: 'customerCode', value: '客户编码' },
                { prop: 'customerGroupName', value: '客户系' }
            ],
            method: 'post',
            prefix: '/api-lcrm',
            advanceUrl: '/customer/info/page',
            cbParams: ['customerCode#opportunityCustomerCode', 'customerName#opportunityCustomerName'],
            isFixed: true,
            span: 4
        },
        {
            name: '销售阶段',
            value: 'saleStages',
            optionNum: 'NEOCRM_SALE_STAGE',
            type: 'select',
            multiple: true,
            span: 4,
            isFixed: true
        },
        {
            name: '分公司',
            value: 'companyName',
            type: 'advance',
            // maxNum: 10, // 多选条数限制
            isFixed: true,
            span: 4,
            advanceConfig: [
                { 'prop': 'companyNameCn', 'value': '分公司名称' },
                { 'prop': 'companyCode', 'value': '分公司编码' }
            ],
            tableConfig: [
                { 'prop': 'companyCode', 'value': '分公司编码' },
                { 'prop': 'companyNameCn', 'value': '分公司名称', 'displayName': 'companyNameCn' }
            ],
            prefix: '/api-mdm',
            advanceUrl: `/esCompany/popCompany`,
            cbParams: ['companyCode', 'companyNameCn#companyName']
        },
        {
            name: '商机业务类型',
            value: 'opportunityEntityType',
            optionNum: 'NEOCRM_OPPORTUNITY_ENTITY_TYPE',
            type: 'select',
            multiple: true,
            span: 4,
            isFixed: true
        }
    ],
    selection: true,
    index: false,
    tableData: {
        columns: [
            {
                label: '商机业务类型',
                prop: 'opportunityEntityType',
                type: 'select',
                optionsKey: 'NEOCRM_OPPORTUNITY_ENTITY_TYPE',
                width: 100
            },
            {
                label: '项目编码',
                prop: 'projectCode',
                width: 160
            },
            {
                label: '项目名称',
                prop: 'projectName',
                width: 160
            },
            {
                label: '商机编码',
                prop: 'opportunityCode',
                width: 130
            },
            {
                label: '商机名称',
                prop: 'opportunityName',
                width: 130
            },
            {
                label: '分公司编码',
                prop: 'companyCode',
                width: 140
            },
            {
                label: '分公司名称',
                prop: 'companyName',
                width: 140
            },
            {
                label: '经营中心编码',
                prop: 'businessCenterCode',
                minWidth: 100
            },
            {
                label: '经营中心',
                prop: 'businessCenterName',
                width: 140
            },
            {
                label: '仓库类型',
                prop: 'warehouseType',
                type: 'select',
                optionsKey: 'NEOCRM_WH_TYPE',
                width: 120
            },
            {
                label: '商机客户编码',
                prop: 'opportunityCustomerCode',
                width: 130
            },
            {
                label: '商机客户名称',
                prop: 'opportunityCustomerName',
                width: 130
            },
            {
                label: '商机类型',
                prop: 'opportunityType',
                type: 'select',
                optionsKey: 'NEOCRM_OPPORTUNITY_TYPE',
                width: 100
            },
            {
                label: '实际中标规模(万)',
                prop: 'totalScale',
                width: 120
            },
            {
                label: '目前规模(万)',
                prop: 'businessScale',
                width: 100
            },
            {
                label: '签单规模(万)',
                prop: 'cdExpectBiddingSize',
                width: 100
            },
            {
                label: '总账期',
                prop: 'contractAccountOf',
                width: 100
            },
            {
                label: '销售阶段',
                prop: 'saleStage',
                type: 'select',
                optionsKey: 'NEOCRM_SALE_STAGE'
            },
            {
                label: '中标日期',
                prop: 'winningDate',
                width: 160
            },
            {
                label: '合同搜索时间',
                prop: 'contractSearchDate',
                width: 160
            },
            {
                label: '商机开发人美信号',
                prop: 'ownerCode',
                width: 120
            },
            {
                label: '商机开发人名称',
                prop: 'ownerName',
                width: 110
            },
            {
                label: '校验客户主体',
                prop: 'isCheck',
                type: 'select',
                optionsKey: 'NEOCRM_YES_NO', // 是否：1是2否,
                width: 100
            },
            {
                label: '报价项目类型',
                prop: 'projectType',
                type: 'select',
                optionsKey: 'NEOCRM_PROJECT_TYPE', // 是否：1是2否,
                // options: [ // TODO
                //     { label: '非标项目', value: '1' },
                //     { label: '标准产品项目', value: '2' },
                //     { label: '待定', value: '3' }
                // ],
                // options: {
                //     1: '非标项目',
                //     2: '标准产品项目',
                //     3: '待定'
                // },
                width: 150
            },
            {
                label: '校验关联商机',
                prop: 'isLinkOppo',
                type: 'select',
                optionsKey: 'NEOCRM_YES_NO', // 是否：1是2否,
                width: 100
            },
            {
                label: '输单阶段',
                prop: 'lostStage',
                type: 'select',
                optionsKey: 'NEOCRM_SALE_STAGE'
            },
            {
                label: '报签确认',
                prop: 'isSign',
                type: 'select',
                optionsKey: 'NEOCRM_YES_NO'
            },
            {
                label: '专业公司',
                prop: 'professionalCompany',
                type: 'select',
                optionsKey: 'BIG_PROFESSIONAL_COMPANY_NAME'
            },
            {
                label: '预计业务量(万元)',
                prop: 'expectedTrafficPlan',
                minWidth: 120
            },
            {
                label: '中标采购毛利率(%)',
                prop: 'grossMarginPlan',
                minWidth: 120
            },
            {
                label: '中标采购毛利率(%)',
                prop: 'grossMarginPlan',
                minWidth: 120
            },
            {
                label: '押金(万)',
                prop: 'deposit'
            },
            {
                label: '结算方式',
                prop: 'settlementMode',
                type: 'select',
                optionsKey: 'SYS_SETTLEMENT'
            },
            {
                label: '承兑比例(%)',
                prop: 'acceptanceRate',
                minWidth: 90
            },
            {
                label: '承兑期限（天）',
                prop: 'acceptanceDays',
                minWidth: 100
            },
            {
                label: '中标项目经营中心利润率(%)',
                prop: 'operatGrossMarginPlan',
                minWidth: 170
            },
            {
                label: '窗口期',
                prop: 'winPeriodWid',
                minWidth: 120
            },
            {
                label: '业务预计启动时间',
                prop: 'businessTime',
                minWidth: 130
            },
            {
                label: '业务类别',
                prop: 'businessCategory',
                type: 'slot',
                optionsKey: 'NEOCRM_BUSINESS_CATEGORY'
            },
            {
                label: '商机开发人所属部门编码',
                prop: 'departCode',
                minWidth: 155
            },
            {
                label: '商机开发人所属部门',
                prop: 'departName',
                minWidth: 130
            },
            {
                label: '落标原因',
                prop: 'lostReasonName',
                type: 'select',
                optionsKey: 'NEOCRM_LOST_REASON_NAME'
            },
            {
                label: '商机大类',
                prop: 'businessType',
                type: 'select',
                optionsKey: 'NEOCRM_BUSINESS_TYPE'
            },
            {
                label: '商机状态',
                prop: 'opportunityStatus',
                type: 'select',
                optionsKey: 'NEOCRM_OPPORTUNITY_STATUS'
            },
            {
                label: '承诺本月可落地签单规模',
                prop: 'salesBeSigned',
                minWidth: 150
            },
            {
                label: '小专司',
                prop: 'smallProfessionalCompany',
                type: 'select',
                optionsKey: 'COST_PROFESSIONAL_COMPANY',
                minWidth: 120
            },
            {
                label: '销售易id',
                prop: 'crmId',
                minWidth: 140
            },
            {
                label: '业务场景大类',
                prop: 'businessScenario',
                minWidth: 100
            },
            {
                label: '商机获取渠道',
                prop: 'opportunitySource',
                type: 'select',
                optionsKey: 'NEOCRM_OPPORTUNITY_SOURCE',
                minWidth: 120
            },
            {
                label: '是否含高货值',
                prop: 'isHighCost',
                type: 'select',
                optionsKey: 'SYS_YES_NO',
                minWidth: 100
            },
            {
                label: '结单日期',
                prop: 'closeDate',
                minWidth: 120
            },
            {
                label: '创建时间',
                prop: 'createTime',
                minWidth: 150
            },
            {
                label: '创建人MIP',
                prop: 'createUserCode'
            },
            {
                label: '创建人名称',
                prop: 'createUserName',
                minWidth: 120
            },
            {
                label: '修改时间',
                prop: 'updateTime',
                minWidth: 150
            },
            {
                label: '修改人mip',
                prop: 'updateUserCode'
            },
            {
                label: '修改人名称',
                prop: 'updateUserName',
                minWidth: 120
            }
        ]
    }
};
